import { DateTime } from "../luxon/luxon";

export default class NewYearTimer {
	constructor(endDate, daysSelector, hoursSelector, minutesSelector, secondsSelector) {
		this.timeend = DateTime.fromISO(endDate, { zone: 'Europe/Moscow' });
		this.daysElement = document.querySelector(daysSelector);
		this.hoursElement = document.querySelector(hoursSelector);
		this.minutesElement = document.querySelector(minutesSelector);
		this.secondsElement = document.querySelector(secondsSelector);
		this.interval = null; // Переменная для хранения интервала
	}

	formatNumber(number) {
		return number < 10 ? '0' + number : number; // Добавляем ведущий ноль
	}

	calculateTime() {
		const now = DateTime.now().setZone('Europe/Moscow');
		let remainingTime = Math.floor((this.timeend - now) / 1000);

		if (remainingTime <= 0) {
			return {
				days: '00',
				hours: '00',
				minutes: '00',
				seconds: '00',
				isFinished: true, // Флаг завершения таймера
			};
		}

		const seconds = remainingTime % 60;
		remainingTime = Math.floor(remainingTime / 60);
		const minutes = remainingTime % 60;
		remainingTime = Math.floor(remainingTime / 60);
		const hours = remainingTime % 24;
		const days = Math.floor(remainingTime / 24);

		return {
			days: this.formatNumber(days),
			hours: this.formatNumber(hours),
			minutes: this.formatNumber(minutes),
			seconds: this.formatNumber(seconds),
			isFinished: false, // Таймер еще не завершен
		};
	}

	updateUI() {
		const { days, hours, minutes, seconds, isFinished } = this.calculateTime();

		if (this.daysElement) this.daysElement.innerHTML = days;
		if (this.hoursElement) this.hoursElement.innerHTML = hours;
		if (this.minutesElement) this.minutesElement.innerHTML = minutes;
		if (this.secondsElement) this.secondsElement.innerHTML = seconds;

		// Останавливаем таймер, если он завершен
		if (isFinished && this.interval) {
			clearInterval(this.interval);
			this.interval = null; // Убираем ссылку на интервал
		}
	}

	start() {
		this.updateUI();
		this.interval = setInterval(() => this.updateUI(), 1000);
	}
}
